export const buttonTextValidations = [
    {
        validationFn: (value, options, { skipValidations } = {}) => {
            if (skipValidations) {
                return true;
            }
            return value && value.trim().length > 0;
        },
        messageId: 'codeless.validation.error.text.empty',
        defaultMessage: 'Enter button text or remove this condition',
    },
];

export const buttonUrlValidations = [
    {
        validationFn: (value, options, { skipValidations } = {}) => {
            if (skipValidations) {
                return true;
            }
            return value && value.trim().length > 0;
        },
        messageId: 'codeless.validation.error.url.empty',
        defaultMessage: 'Enter URL or remove this condition',
    },
];
